import React from 'react';
import GridContainer from '../../../../Grid/GridContainer';
import GridItem from '../../../../Grid/GridItem';
import CustomInput from '../../../../CustomInput/CustomInput';
import ValidationInput from '../../../../ValidationInput';
import moment from 'moment';
import { AddressValidationInput } from './TransferServiceInfoEdit';
import { convertTo12HourFormat } from '../../../../../util/dateUtils/dateFormatters';

const TransferServiceInfo = ({
  event,
  appointment,
  formatTransferTypeRecive,
  formatDistance,
  translateStatus,
  formatPatientAddress,
  getTransferWayLabel,
  isOneWay,
  t
}: any) => {


  const getDriverName = (): string => {
    const driver = event?.origin?.driver ?? event?.origin?.transferItemRequestId?.driver;
    if (!driver) return "-";
    return `${driver.firstName ?? ''}, ${driver.lastName ?? ''}`.trim() ?? "-";
  };


  return (
    <GridContainer>
      <GridItem xs={6} sm={6} md={6}>
        <CustomInput
          labelText={t('service.type')}
          disabled={true}
          value={getTransferWayLabel()}
        />
      </GridItem>
      <GridItem xs={6} sm={6} md={6}>
        <CustomInput
          labelText={t("service.traslado")}
          disabled={true}
          value={formatTransferTypeRecive(event?.origin?.transferItemRequestId?.transferType)}
        />
      </GridItem>
      <GridItem xs={6} sm={6} md={6}>
        <CustomInput
          labelText={t("reassignAppointments.table.transferId")}
          disabled={true}
          value={event?.id}
        />
      </GridItem>
      <GridItem xs={6} sm={6} md={6}>
        <CustomInput
          labelText={t('label.provider')}
          disabled={true}
          value={event?.origin?.transferItemRequestId?.companyIdPartnership?.name}
        />
      </GridItem>
      <GridItem xs={6} sm={6} md={6}>
        <CustomInput
          labelText={t("common.driver")}
          disabled={true}
          value={getDriverName()}
        />
      </GridItem>
      <GridItem xs={6} sm={6} md={6}>
        <CustomInput
          labelText={t('label.startDate')}
          disabled={true}
          value={moment(event?.origin?.startDateTime).format('DD/MM/YYYY')}
        />
      </GridItem>

      <AddressValidationInput
        text={t('service.source.address')}
        isOneWay={isOneWay}
        event={event}
        appointment={appointment}
        formatPatientAddress={formatPatientAddress}
        type="source"
      />

      <GridItem xs={6} sm={6} md={6}>
        <CustomInput
          labelText={t('service.stimated.pickup.time')}
          disabled={true}
          value={convertTo12HourFormat(event?.origin?.transferScheduleDateTime ?? event?.startDateTime)}
        />
      </GridItem>
      <GridItem xs={6} sm={6} md={6}>
        <CustomInput
          labelText={t('service.real.pickup.time')}
          disabled={true}
          value={
            (event?.origin?.transferScheduleStatus === 'DONE' || event?.origin?.transferScheduleStatus === 'ENDED')
              ? convertTo12HourFormat(event?.origin?.startDateTime)
              : ''
          }
        />
      </GridItem>

      <AddressValidationInput
        text={isOneWay ? t('service.institution.destination') : t('service.address')}
        isOneWay={isOneWay}
        event={event}
        appointment={appointment}
        formatPatientAddress={formatPatientAddress}
        type="destination"
      />

      <GridItem xs={6} sm={6} md={6} className="timeInput">
        <CustomInput
          labelText={t('service.stimated.arrival.time')}
          disabled={true}
          value={convertTo12HourFormat(event?.origin?.transferScheduleEndDateTime ?? event?.transferScheduleEndDateTime)}
        />
      </GridItem>
      <GridItem xs={6} sm={6} md={6}>
        <CustomInput
          type="text"
          disabled={true}
          labelText={t('service.real.arrival.time')}
          value={
            (event?.origin?.transferScheduleStatus === 'DONE' || event?.origin?.transferScheduleStatus === 'ENDED')
              ? convertTo12HourFormat(event?.origin?.endDateTime ?? event?.transferScheduleEndDateTime)
              : ''
          }
        />
      </GridItem>
      <GridItem xs={6} sm={6} md={6}>
        <CustomInput
          type="text"
          disabled={true}
          labelText={t('service.estimated.distance')}
          value={formatDistance(event?.origin?.geoDistance, true)}
        />
      </GridItem>
      <GridItem xs={6} sm={6} md={6}>
        <CustomInput
          type="text"
          disabled={true}
          labelText={t('service.real.distance')}
          value={formatDistance(event?.origin?.geoTrackDistance, true)}
        />
      </GridItem>
      <GridItem xs={12} sm={12} md={12} className="no-padding">
        <ValidationInput
          type="text"
          disabled={true}
          inputProps={{ style: { width: "100%" } }}
          text={t('status')}
          value={translateStatus(event?.origin?.transferScheduleStatus)}
        />
      </GridItem>
    </GridContainer>
  );
};

export default TransferServiceInfo; 